var map = {
	"./de/title.png": "oxMk",
	"./en/title.png": "hwf4",
	"./es/title.png": "/vHe",
	"./fr/title.png": "t0Ep",
	"./ja/title.png": "+pmx",
	"./ko/title.png": "83sm",
	"./pt/title.png": "pEdO",
	"./ru/title.png": "Jdg6",
	"./tc/title.png": "sJj3",
	"./th/title.png": "gSik"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5BXS";